<template>
    <div class="active-users-barchart">
        <h2>Aktive brukere per år</h2>
        <p class="text-muted">Diagrammet viser antall unike brukere som har registrert plukk i hver plukkegruppe. En bruker kan telles i flere plukkegrupper.</p>
        <highcharts :options="chartOptions" :highcharts="Highcharts"></highcharts>
    </div>
</template>
<script>
import { Chart } from 'highcharts-vue';
import Highcharts from '../../highcharts';

export default {
    components: {
        highcharts: Chart,
    },
    created() {
        this.Highcharts = Highcharts;
    },
    data() {
        return {
            years: [],
            series: [],
        };
    },
    computed: {
        chartOptions() {
            return {
                chart: {
                    type: 'column',
                },
                title: {
                    text: null,
                },
                xAxis: {
                    categories: this.years.map(year => String(year)),
                },
                yAxis: {
                    title: { text: 'Antall aktive brukere' },
                    min: 0,
                    allowDecimals: false,
                },
                series: this.series,
                credits: {
                    enabled: false,
                },
            };
        },
    },
    mounted() {
        this.fetchActiveUsers();
    },
    methods: {
        async fetchActiveUsers() {
            try {
                const response = await fetch('/api/v1/statistics/active-users');
                const data = await response.json();
                this.years = data.years;
                this.series = data.series;
            } catch (error) {
                console.error(error);
            }
        },
    },
};
</script>
